import HistoryIcon from '@mui/icons-material/History'
import { IconButton } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useAppTranslations } from '../../../../../utils/hooks/useAppTranslations'
import { BudgetHistoryPopover } from './BudgetHistoryPopover'
import { useAdGroupBudgetHistory } from './useAdGroupBudgetHistory'

type BudgetHistoryButtonsProps = {
  adGroupId: number | string
}

export const BudgetHistoryButtons: React.FC<BudgetHistoryButtonsProps> = ({ adGroupId }) => {
  const t = useAppTranslations()
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLElement | null>(null)
  const closePopoverTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const { changes, loading, error } = useAdGroupBudgetHistory(adGroupId)

  const popoverOpen = Boolean(popoverAnchor)
  const openLabel = t('adgroup.spentBudget.history.open')

  const cancelClosePopover = (): void => {
    if (closePopoverTimeoutRef.current) {
      clearTimeout(closePopoverTimeoutRef.current)
      closePopoverTimeoutRef.current = null
    }
  }

  const openPopover = (anchor: HTMLElement): void => {
    cancelClosePopover()
    setPopoverAnchor(anchor)
  }

  const scheduleClosePopover = (): void => {
    cancelClosePopover()
    closePopoverTimeoutRef.current = setTimeout(() => setPopoverAnchor(null), 150)
  }

  useEffect(
    () => () => {
      cancelClosePopover()
    },
    []
  )

  return (
    <>
      <IconButton
        size="small"
        aria-label={openLabel}
        onMouseEnter={(event) => openPopover(event.currentTarget)}
        onMouseLeave={scheduleClosePopover}
      >
        <HistoryIcon fontSize="small" />
      </IconButton>
      <BudgetHistoryPopover
        anchorEl={popoverAnchor}
        open={popoverOpen}
        onClose={() => setPopoverAnchor(null)}
        onContentMouseEnter={cancelClosePopover}
        onContentMouseLeave={scheduleClosePopover}
        changes={changes}
        loading={loading}
        error={error}
      />
    </>
  )
}
